import './SegmentField.css';

import { Container, Form, Row } from 'react-bootstrap';
import React, { useState } from 'react';

const RTS_MT = 'MT';
const RTS_TM = 'TM';
const RTS_LLM = 'LLM';

const SegmentField = ({ data, isLuma }) => {
  const [showTags, setShowTags] = useState(false);
  const isTm = data?.translationSystem === RTS_TM;
  const label = isTm ? RTS_TM : isLuma ? RTS_LLM : RTS_MT;

  return (
    <Container className={`p-1 border-radius-5 segment-field-${isTm ? RTS_TM : RTS_MT}`}>
      <span>{label}</span>
      <Form.Label className="mb-1 d-inline-block color-darkblue cursor-pointer" onClick={() => setShowTags(!showTags)}>
        {(showTags ? 'Hide' : 'Show') + ' tags'}
      </Form.Label>
      <Row className="m-0 bg-purple pt-2" noGutters>
        <Form.Label>Original Segment</Form.Label>
        <p className="ml-1">{showTags ? data?.requestTextToTranslationSystem : data?.sourceText}</p>
      </Row>
      <Row className="pt-2" noGutters>
        <Form.Label>Translated Segment</Form.Label>
        <p className="ml-1">{showTags ? data?.responseTextFromTranslationSystem : data?.translatedText}</p>
      </Row>
    </Container>
  );
};

export default SegmentField;
